import type { AlpineComponent } from 'alpinejs';

type NavProps = {
	state: number[];
};

export const nav = (): AlpineComponent<NavProps> => ({
	state: [],
	reset(): void {
		this.state = [];
	},
	replace(level: number, id: number): void {
		this.state = [...this.state.filter((_, i) => i < level), id];
	},
	includes(id: number): boolean {
		return this.state.includes(id);
	},
    setNavHeight(): void {
        let header = document.querySelector('.header__inner'),
            menu = document.querySelector('.mega-menu');

        if (header && menu) {
            menu.style.maxHeight=`calc(100vh - ${header.offsetHeight}px)`;
        }
    },
	get hasLength() {
		return Boolean(this.state.length);
	}
});
